(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/suspensionhistoryitem.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/suspensionhistoryitem.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.SuspensionHistoryItem = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.suspensionhistoryitem(data);
    },
    className: 'zebra-list-item',
    tagName: 'tr'
  });
})(Backbone, _, svs);

 })(window);